export interface ScorInvoiceRow extends ApiScorInvoice {
  paidAt?: string;
  rowKey: string;
}

export const getScorInvoiceListStatus = (
  invoice: ApiScorInvoice
): 'paid' | 'overdue' | 'waiting' | 'closed' | 'refunded' => {
  if (invoice.status === 2) return 'paid';
  if (invoice.status === 8) return 'closed';
  if (invoice.status === 9) return 'refunded';
  if (invoice.status === 3 || invoice.is_overdue) return 'overdue';

  return 'waiting';
};

export const buildScorInvoiceRows = (
  invoices: ApiScorInvoice[] = [],
  purchases: ApiScorPurchaseItem[] = []
): ScorInvoiceRow[] => {
  const rows = new Map<string, ScorInvoiceRow>();
  invoices.forEach((invoice, index) => {
    const rowKey = invoice.id == null ? `invoice-${index}` : `id-${invoice.id}`;
    rows.set(rowKey, { ...invoice, rowKey });
  });
  purchases.forEach((purchase, index) => {
    const rowKey =
      purchase.id == null ? `purchase-${index}` : `id-${purchase.id}`;
    rows.set(rowKey, {
      ...rows.get(rowKey),
      ...purchase,
      status: 2,
      status_label: undefined,
      is_overdue: false,
      paidAt: purchase.paid_at,
      rowKey,
    });
  });
  const timestamp = (row: ScorInvoiceRow): number => {
    const date = Date.parse(row.paidAt ?? row.issued_at ?? '');

    return Number.isNaN(date) ? 0 : date;
  };

  return Array.from(rows.values()).sort((a, b) => timestamp(b) - timestamp(a));
};
